const base_url = process.env.REACT_APP_BASE_URL;
const book_now_url = `${base_url}/website/v1/contact-us`;
const city_url = `${base_url}/state/v1/get/4/city`;
const vehicle_brand_url = `${base_url}/vehicle-brand/v1/brand/get`;
export { base_url, book_now_url, city_url, vehicle_brand_url };
